import { useParams, useNavigate } from 'react-router-dom'
import { useState } from 'react'

export default function Customize() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [fabric, setFabric] = useState('linen')
  const [sleeve, setSleeve] = useState('sleeveless')
  const [length, setLength] = useState('floor')

 const dressDetails = {
  1: { name: 'Bloom Cream', image: '/images/dress1.jpg' },
  2: { name: 'Vintage Rose', image: '/images/dress2.jpg' },
  3: { name: 'Floral Berry', image: '/images/dress3.jpg' },
  4: { name: 'Clementine Garden', image: '/images/dress4.jpg' },
  5: { name: 'Twilight Meadow', image: '/images/dress5.jpg' }
}

  const currentDress = dressDetails[id] || { name: 'Custom Dress', image: '/images/dress1.jpg' }
  const totalPrice = 6000

  const fabricOptions = {
    linen: { name: 'Linen', price: 0 },
    cotton: { name: 'Cotton', price: 0 }
  }

  const sleeveOptions = {
    sleeveless: { name: 'Sleeveless', price: 0 },
    short: { name: 'Short Sleeve', price: 0 },
    elbow: { name: 'Elbow Length', price: 0 },
    long: { name: 'Long Sleeve', price: 0 }
  }

  const lengthOptions = {
    knee: { name: 'Knee Length', price: 0 },
    tea: { name: 'Tea Length', price: 0 },
    floor: { name: 'Floor Length', price: 0 },
    train: { name: 'With Train', price: 0 }
  }

  const handleContinue = () => {
    navigate('/measurements', {
      state: {
        dress: { name: currentDress.name, basePrice: 6000, image: currentDress.image },
        fabric: fabricOptions[fabric],
        sleeve: sleeveOptions[sleeve],
        length: lengthOptions[length],
        totalPrice: totalPrice
      }
    })
  }

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-2">Customize Your {currentDress.name}</h1>
      <p className="text-gray-600 mb-8">Choose your preferences below (all options included in price)</p>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-gradient-to-br from-rose-100 to-pink-200 rounded-2xl p-8 flex items-center justify-center min-h-[400px]">
          <div className="text-center w-full">
            <img 
              src={currentDress.image} 
              alt={currentDress.name}
              className="w-full max-h-80 object-cover rounded-lg shadow-md"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div class="text-8xl">👗</div>';
              }}
            />
            <p className="text-lg font-semibold mt-4">{currentDress.name}</p>
            <p className="text-sm text-gray-600">{fabricOptions[fabric].name} · {sleeveOptions[sleeve].name} · {lengthOptions[length].name}</p>
          </div>
        </div>

        <div className="space-y-6">
          {/* Fabric Selection - Only Linen & Cotton */}
          <div>
            <label className="block font-semibold mb-3">Fabric</label>
            <div className="flex gap-3">
              {Object.entries(fabricOptions).map(([key, opt]) => (
                <button
                  key={key}
                  onClick={() => setFabric(key)}
                  className={`flex-1 p-3 rounded-xl border-2 transition ${
                    fabric === key 
                      ? 'border-rose-600 bg-rose-50 text-rose-700' 
                      : 'border-gray-200 hover:border-rose-300'
                  }`}
                >
                  <div className="font-medium">{opt.name}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Sleeve Selection */}
          <div>
            <label className="block font-semibold mb-3">Sleeve Length</label>
            <div className="grid grid-cols-2 gap-3">
              {Object.entries(sleeveOptions).map(([key, opt]) => (
                <button
                  key={key}
                  onClick={() => setSleeve(key)}
                  className={`p-3 rounded-xl border-2 transition ${
                    sleeve === key 
                      ? 'border-rose-600 bg-rose-50' 
                      : 'border-gray-200 hover:border-rose-300'
                  }`}
                >
                  <div className="font-medium">{opt.name}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Length Selection */}
          <div>
            <label className="block font-semibold mb-3">Dress Length</label>
            <div className="grid grid-cols-2 gap-3">
              {Object.entries(lengthOptions).map(([key, opt]) => (
                <button
                  key={key}
                  onClick={() => setLength(key)}
                  className={`p-3 rounded-xl border-2 transition ${
                    length === key 
                      ? 'border-rose-600 bg-rose-50' 
                      : 'border-gray-200 hover:border-rose-300'
                  }`}
                >
                  <div className="font-medium">{opt.name}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white rounded-xl border p-6 flex justify-between items-center">
        <div>
          <p className="text-gray-500">Total Price</p>
          <p className="text-3xl font-bold text-rose-700">Rs. {totalPrice.toLocaleString()}</p>
          <p className="text-xs text-gray-400 mt-1">All customizations included</p>
        </div>
        <button 
          onClick={handleContinue}
          className="bg-rose-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-rose-700 transition"
        >
          Continue to Measurements →
        </button>
      </div>
    </div>
  )
}
